import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export function PatientOverviewActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 39 46">
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g
                    id="assets-and-interactions"
                    transform="translate(-162.000000, -733.000000)"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                >
                    <g id="icon-overview-active" transform="translate(163.000000, 734.000000)">
                        <path d="M6,27.5 L32,27.5" id="Stroke-1" />
                        <path d="M22,22.5 L32,22.5" id="Stroke-2" />
                        <path d="M22,16.5 L32,16.5" id="Stroke-3" />
                        <path d="M22,11.5 L32,11.5" id="Stroke-4" />
                        <path d="M6,36.5 L32,36.5" id="Stroke-5" />
                        <path d="M5,31.5 L16,31.5" id="Stroke-6" />
                        <path d="M22,31.5 L32,31.5" id="Stroke-7" />
                        <path d="M18.5,31.5 L18.5,31.5" id="Stroke-8" />
                        <g id="Group-13">
                            <polygon
                                id="Stroke-9"
                                points="17.3673469 21.2413793 11.3265306 16.6896552 5.28571429 21.2413793 5.28571429 0 17.3673469 0"
                            />
                            <polygon
                                id="Stroke-11"
                                points="17.3673469 3.03448276 17.3673469 21.2413793 11.3265306 16.6896552 5.28571429 21.2413793 5.28571429 3.03448276 0 3.03448276 0 44 37 44 37 3.03448276"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function PatientOverviewInActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 39 46">
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g
                    id="assets-and-interactions"
                    transform="translate(-163.000000, -331.000000)"
                    stroke="#000000"
                    strokeWidth="2"
                >
                    <g id="icon-overview-Inactive" transform="translate(164.000000, 332.000000)">
                        <path d="M6,27.5 L32,27.5" id="Stroke-1" />
                        <path d="M22,22.5 L32,22.5" id="Stroke-2" />
                        <path d="M22,16.5 L32,16.5" id="Stroke-3" />
                        <path d="M22,11.5 L32,11.5" id="Stroke-4" />
                        <path d="M6,36.5 L32,36.5" id="Stroke-5" />
                        <path d="M5,31.5 L16,31.5" id="Stroke-6" />
                        <path d="M22,31.5 L32,31.5" id="Stroke-7" />
                        <path d="M18.5,31.5 L18.5,31.5" id="Stroke-8" />
                        <g id="Group-13">
                            <polygon
                                id="Stroke-9"
                                points="17.3673469 21.2413793 11.3265306 16.6896552 5.28571429 21.2413793 5.28571429 0 17.3673469 0"
                            />
                            <polygon
                                id="Stroke-11"
                                points="17.3673469 3.03448276 17.3673469 21.2413793 11.3265306 16.6896552 5.28571429 21.2413793 5.28571429 3.03448276 0 3.03448276 0 44 37 44 37 3.03448276"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function PatientPaymentMethodsActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 60 59">
            <defs>
                <polygon id="path-1" points="0 59.0156 60 59.0156 60 -0.0004 0 -0.0004"></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="assets-and-interactions" transform="translate(-877.000000, -818.000000)">
                    <g id="icon-payment-methods-active" transform="translate(877.000000, 818.000000)">
                        <path
                            d="M55,50 L51,57 L47,50 L47,2.985 C47,1.889 47.889,1 48.985,1 L53.015,1 C54.111,1 55,1.889 55,2.985 L55,50 Z"
                            id="Stroke-1"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                        ></path>
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1"></use>
                        </mask>
                        <g id="Clip-4"></g>
                        <polygon
                            id="Stroke-3"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            mask="url(#mask-2)"
                            points="47 11.9996 55 11.9996 55 7.9996 47 7.9996"
                        ></polygon>
                        <path
                            d="M47,50 L55,50"
                            id="Stroke-5"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            mask="url(#mask-2)"
                        ></path>
                        <polygon
                            id="Stroke-6"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            mask="url(#mask-2)"
                            points="1 46.9996 47 46.9996 47 15.9996 1 15.9996"
                        ></polygon>
                        <polygon
                            id="Stroke-7"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            mask="url(#mask-2)"
                            points="55 46.9996 59 46.9996 59 15.9996 55 15.9996"
                        ></polygon>
                        <path
                            d="M36,27 L39,27"
                            id="Stroke-8"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M21,23 L24,23"
                            id="Stroke-9"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M32,23 L39,23"
                            id="Stroke-10"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M28,23 L28,23"
                            id="Stroke-11"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M25,27 L32,27"
                            id="Stroke-12"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M21,27 L21,27"
                            id="Stroke-13"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M6,34.2227 C6,36.4317 7.791,38.2227 10,38.2227 C11.225,38.2227 12.321,37.6717 13.055,36.8047 C13.986,35.7027 13.753,34.0307 12.615,33.1457 L7.385,29.0767 C6.247,28.1917 6.014,26.5187 6.945,25.4177 C7.679,24.5507 8.775,23.9997 10,23.9997 C12.209,23.9997 14,25.7907 14,27.9997"
                            id="Stroke-14"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <polyline
                            id="Stroke-15"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                            points="10 22 10 35 10 40"
                        ></polyline>
                        <path
                            d="M24.1445,33.4004 C21.3025,34.8794 20.9035,38.1134 20.8065,41.0004 C21.3745,40.7644 21.9435,40.5284 22.5135,40.2934 C21.5775,39.5094 20.6425,38.7254 19.7075,37.9424 C18.7265,37.1214 17.3045,38.5284 18.2925,39.3564 C19.2275,40.1394 20.1635,40.9234 21.0995,41.7074 C21.7575,42.2584 22.7755,41.9104 22.8065,41.0004 C22.8785,38.8344 22.9805,36.2574 25.1545,35.1274 C26.2965,34.5334 25.2865,32.8064 24.1445,33.4004"
                            id="Fill-16"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M25.1318,38.5039 C25.6498,39.5539 26.6318,40.2869 27.8008,40.4359 C28.3958,40.5109 28.9328,40.4269 29.4888,40.2099 C29.8988,40.0509 31.4258,38.9019 31.7568,39.4929 C32.3838,40.6159 34.1118,39.6089 33.4838,38.4829 C32.9458,37.5229 31.8588,37.1419 30.7948,37.3889 C29.4098,37.7099 27.8338,39.4719 26.8588,37.4949 C26.2898,36.3409 24.5638,37.3529 25.1318,38.5039"
                            id="Fill-17"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}
export function PatientPaymentMethodsInActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 60 59">
            <defs>
                <polygon id="path-1" points="0 59.0156 60 59.0156 60 -0.0004 0 -0.0004"></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="assets-and-interactions" transform="translate(-869.000000, -324.000000)">
                    <g id="icon-payment-methods-Inactive" transform="translate(869.000000, 324.000000)">
                        <path
                            d="M55,50 L51,57 L47,50 L47,2.985 C47,1.889 47.889,1 48.985,1 L53.015,1 C54.111,1 55,1.889 55,2.985 L55,50 Z"
                            id="Stroke-1"
                            stroke="#000000"
                            strokeWidth="2"
                        />
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1" />
                        </mask>
                        <g id="Clip-4" />
                        <polygon
                            id="Stroke-3"
                            stroke="#000000"
                            strokeWidth="2"
                            mask="url(#mask-2)"
                            points="47 11.9996 55 11.9996 55 7.9996 47 7.9996"
                        />
                        <path d="M47,50 L55,50" id="Stroke-5" stroke="#000000" strokeWidth="2" mask="url(#mask-2)" />
                        <polygon
                            id="Stroke-6"
                            stroke="#000000"
                            strokeWidth="2"
                            mask="url(#mask-2)"
                            points="1 46.9996 47 46.9996 47 15.9996 1 15.9996"
                        />
                        <polygon
                            id="Stroke-7"
                            stroke="#000000"
                            strokeWidth="2"
                            mask="url(#mask-2)"
                            points="55 46.9996 59 46.9996 59 15.9996 55 15.9996"
                        />
                        <path
                            d="M36,27 L39,27"
                            id="Stroke-8"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        />
                        <path
                            d="M21,23 L24,23"
                            id="Stroke-9"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        />
                        <path
                            d="M32,23 L39,23"
                            id="Stroke-10"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        />
                        <path
                            d="M28,23 L28,23"
                            id="Stroke-11"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        />
                        <path
                            d="M25,27 L32,27"
                            id="Stroke-12"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        />
                        <path
                            d="M21,27 L21,27"
                            id="Stroke-13"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        />
                        <path
                            d="M6,34.2227 C6,36.4317 7.791,38.2227 10,38.2227 C11.225,38.2227 12.321,37.6717 13.055,36.8047 C13.986,35.7027 13.753,34.0307 12.615,33.1457 L7.385,29.0767 C6.247,28.1917 6.014,26.5187 6.945,25.4177 C7.679,24.5507 8.775,23.9997 10,23.9997 C12.209,23.9997 14,25.7907 14,27.9997"
                            id="Stroke-14"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        />
                        <polyline
                            id="Stroke-15"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                            points="10 22 10 35 10 40"
                        />
                        <path
                            d="M24.1445,33.4004 C21.3025,34.8794 20.9035,38.1134 20.8065,41.0004 C21.3745,40.7644 21.9435,40.5284 22.5135,40.2934 C21.5775,39.5094 20.6425,38.7254 19.7075,37.9424 C18.7265,37.1214 17.3045,38.5284 18.2925,39.3564 C19.2275,40.1394 20.1635,40.9234 21.0995,41.7074 C21.7575,42.2584 22.7755,41.9104 22.8065,41.0004 C22.8785,38.8344 22.9805,36.2574 25.1545,35.1274 C26.2965,34.5334 25.2865,32.8064 24.1445,33.4004"
                            id="Fill-16"
                            fill="#000000"
                            mask="url(#mask-2)"
                        />
                        <path
                            d="M25.1318,38.5039 C25.6498,39.5539 26.6318,40.2869 27.8008,40.4359 C28.3958,40.5109 28.9328,40.4269 29.4888,40.2099 C29.8988,40.0509 31.4258,38.9019 31.7568,39.4929 C32.3838,40.6159 34.1118,39.6089 33.4838,38.4829 C32.9458,37.5229 31.8588,37.1419 30.7948,37.3889 C29.4098,37.7099 27.8338,39.4719 26.8588,37.4949 C26.2898,36.3409 24.5638,37.3529 25.1318,38.5039"
                            id="Fill-17"
                            fill="#000000"
                            mask="url(#mask-2)"
                        />
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function CreditCardActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 60 44">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="assets-and-interactions"
                    transform="translate(-666.000000, -376.000000)"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                >
                    <g id="icon-credit-card-selected" transform="translate(667.000000, 377.000000)">
                        <path
                            d="M54.7832,42 L3.2172,42 C1.4402,42 0.0002,40.56 0.0002,38.783 L0.0002,3.217 C0.0002,1.44 1.4402,0 3.2172,0 L54.7832,0 C56.5592,0 58.0002,1.44 58.0002,3.217 L58.0002,38.783 C58.0002,40.56 56.5592,42 54.7832,42 Z"
                            id="Stroke-1"
                        ></path>
                        <path d="M6,29 L15,29" id="Stroke-3" strokeLinecap="round"></path>
                        <path d="M19,29 L28,29" id="Stroke-5" strokeLinecap="round"></path>
                        <path d="M6,34 L7,34" id="Stroke-7" strokeLinecap="round"></path>
                        <path d="M11,34 L13,34" id="Stroke-9" strokeLinecap="round"></path>
                        <path d="M17,34 L18,34" id="Stroke-11" strokeLinecap="round"></path>
                        <path d="M22,34 L24,34" id="Stroke-13" strokeLinecap="round"></path>
                        <path d="M28,34 L28,34" id="Stroke-15" strokeLinecap="round"></path>
                        <path
                            d="M46,31 C46,34.313 43.313,37 40,37 C36.687,37 34,34.313 34,31 C34,27.687 36.687,25 40,25 C43.313,25 46,27.687 46,31 Z"
                            id="Stroke-17"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M53,31 C53,34.313 50.313,37 47,37 C43.687,37 41,34.313 41,31 C41,27.687 43.687,25 47,25 C50.313,25 53,27.687 53,31 Z"
                            id="Stroke-19"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M20.7451,20 L7.2551,20 C6.5611,20 6.0001,19.438 6.0001,18.745 L6.0001,9.255 C6.0001,8.562 6.5611,8 7.2551,8 L20.7451,8 C21.4381,8 22.0001,8.562 22.0001,9.255 L22.0001,18.745 C22.0001,19.438 21.4381,20 20.7451,20 Z"
                            id="Stroke-21"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M22,9.2549 C22,8.5619 21.438,7.9999 20.745,7.9999 L16,7.9999 L13.255,7.9999 C12.562,7.9999 12,8.5619 12,9.2549 L12,11.9999 L12,18.7449 C12,19.4379 12.562,19.9999 13.255,19.9999 L14.745,19.9999 C15.438,19.9999 16,19.4379 16,18.7449 L16,13.2549 C16,12.5619 16.562,11.9999 17.255,11.9999 L20.745,11.9999 C21.438,11.9999 22,11.4379 22,10.7449 L22,9.2549 Z"
                            id="Stroke-23"
                            strokeLinecap="round"
                        ></path>
                        <path d="M16,16 L22,16" id="Stroke-25" strokeLinecap="round"></path>
                        <path d="M12,12 L6,12" id="Stroke-27" strokeLinecap="round"></path>
                        <path d="M12,16 L6,16" id="Stroke-29" strokeLinecap="round"></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function CreditCardInActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 60 44">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="assets-and-interactions"
                    transform="translate(-106.000000, -374.000000)"
                    stroke="#000000"
                    strokeWidth="2"
                >
                    <g id="icon-credit-card" transform="translate(107.000000, 375.000000)">
                        <path
                            d="M54.7832,42 L3.2172,42 C1.4402,42 0.0002,40.56 0.0002,38.783 L0.0002,3.217 C0.0002,1.44 1.4402,0 3.2172,0 L54.7832,0 C56.5592,0 58.0002,1.44 58.0002,3.217 L58.0002,38.783 C58.0002,40.56 56.5592,42 54.7832,42 Z"
                            id="Stroke-1"
                        ></path>
                        <path d="M6,29 L15,29" id="Stroke-3" strokeLinecap="round"></path>
                        <path d="M19,29 L28,29" id="Stroke-5" strokeLinecap="round"></path>
                        <path d="M6,34 L7,34" id="Stroke-7" strokeLinecap="round"></path>
                        <path d="M11,34 L13,34" id="Stroke-9" strokeLinecap="round"></path>
                        <path d="M17,34 L18,34" id="Stroke-11" strokeLinecap="round"></path>
                        <path d="M22,34 L24,34" id="Stroke-13" strokeLinecap="round"></path>
                        <path d="M28,34 L28,34" id="Stroke-15" strokeLinecap="round"></path>
                        <path
                            d="M46,31 C46,34.313 43.313,37 40,37 C36.687,37 34,34.313 34,31 C34,27.687 36.687,25 40,25 C43.313,25 46,27.687 46,31 Z"
                            id="Stroke-17"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M53,31 C53,34.313 50.313,37 47,37 C43.687,37 41,34.313 41,31 C41,27.687 43.687,25 47,25 C50.313,25 53,27.687 53,31 Z"
                            id="Stroke-19"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M20.7451,20 L7.2551,20 C6.5611,20 6.0001,19.438 6.0001,18.745 L6.0001,9.255 C6.0001,8.562 6.5611,8 7.2551,8 L20.7451,8 C21.4381,8 22.0001,8.562 22.0001,9.255 L22.0001,18.745 C22.0001,19.438 21.4381,20 20.7451,20 Z"
                            id="Stroke-21"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M22,9.2549 C22,8.5619 21.438,7.9999 20.745,7.9999 L16,7.9999 L13.255,7.9999 C12.562,7.9999 12,8.5619 12,9.2549 L12,11.9999 L12,18.7449 C12,19.4379 12.562,19.9999 13.255,19.9999 L14.745,19.9999 C15.438,19.9999 16,19.4379 16,18.7449 L16,13.2549 C16,12.5619 16.562,11.9999 17.255,11.9999 L20.745,11.9999 C21.438,11.9999 22,11.4379 22,10.7449 L22,9.2549 Z"
                            id="Stroke-23"
                            strokeLinecap="round"
                        ></path>
                        <path d="M16,16 L22,16" id="Stroke-25" strokeLinecap="round"></path>
                        <path d="M12,12 L6,12" id="Stroke-27" strokeLinecap="round"></path>
                        <path d="M12,16 L6,16" id="Stroke-29" strokeLinecap="round"></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function DebitCardActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 60 44">
            <defs>
                <polygon id="path-1" points="0 44 60 44 60 0 0 0"></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="assets-and-interactions" transform="translate(-666.000000, -523.000000)">
                    <g id="icon-debit-card-selected" transform="translate(666.000000, 523.000000)">
                        <path
                            d="M55.7832,43 L4.2172,43 C2.4402,43 1.0002,41.56 1.0002,39.783 L1.0002,4.217 C1.0002,2.44 2.4402,1 4.2172,1 L55.7832,1 C57.5592,1 59.0002,2.44 59.0002,4.217 L59.0002,39.783 C59.0002,41.56 57.5592,43 55.7832,43 Z"
                            id="Stroke-1"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                        ></path>
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1"></use>
                        </mask>
                        <g id="Clip-4"></g>
                        <polygon
                            id="Stroke-3"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                            points="1 14 59 14 59 6 1 6"
                        ></polygon>
                        <path
                            d="M7,20 L16,20"
                            id="Stroke-5"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M20,20 L29,20"
                            id="Stroke-6"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M7,25 L8,25"
                            id="Stroke-7"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M12,25 L14,25"
                            id="Stroke-8"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M18,25 L19,25"
                            id="Stroke-9"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M23,25 L25,25"
                            id="Stroke-10"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M29,25 L29,25"
                            id="Stroke-11"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M25,10 C25,10.552 24.553,11 24,11 C23.447,11 23,10.552 23,10 C23,9.448 23.447,9 24,9 C24.553,9 25,9.448 25,10"
                            id="Fill-12"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M28,7 C28,7.552 27.553,8 27,8 C26.447,8 26,7.552 26,7 C26,6.448 26.447,6 27,6 C27.553,6 28,6.448 28,7"
                            id="Fill-13"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M28,13 C28,13.552 27.553,14 27,14 C26.447,14 26,13.552 26,13 C26,12.448 26.447,12 27,12 C27.553,12 28,12.448 28,13"
                            id="Fill-14"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M31,10 C31,10.552 30.553,11 30,11 C29.447,11 29,10.552 29,10 C29,9.448 29.447,9 30,9 C30.553,9 31,9.448 31,10"
                            id="Fill-15"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M19,10 C19,10.552 18.553,11 18,11 C17.447,11 17,10.552 17,10 C17,9.448 17.447,9 18,9 C18.553,9 19,9.448 19,10"
                            id="Fill-16"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M22,7 C22,7.552 21.553,8 21,8 C20.447,8 20,7.552 20,7 C20,6.448 20.447,6 21,6 C21.553,6 22,6.448 22,7"
                            id="Fill-17"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M22,13 C22,13.552 21.553,14 21,14 C20.447,14 20,13.552 20,13 C20,12.448 20.447,12 21,12 C21.553,12 22,12.448 22,13"
                            id="Fill-18"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M4,7 C4,7.552 3.553,8 3,8 C2.447,8 2,7.552 2,7 C2,6.448 2.447,6 3,6 C3.553,6 4,6.448 4,7"
                            id="Fill-19"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M4,13 C4,13.552 3.553,14 3,14 C2.447,14 2,13.552 2,13 C2,12.448 2.447,12 3,12 C3.553,12 4,12.448 4,13"
                            id="Fill-20"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M7,10 C7,10.552 6.553,11 6,11 C5.447,11 5,10.552 5,10 C5,9.448 5.447,9 6,9 C6.553,9 7,9.448 7,10"
                            id="Fill-21"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M13,10 C13,10.552 12.553,11 12,11 C11.447,11 11,10.552 11,10 C11,9.448 11.447,9 12,9 C12.553,9 13,9.448 13,10"
                            id="Fill-22"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M10,7 C10,7.552 9.553,8 9,8 C8.447,8 8,7.552 8,7 C8,6.448 8.447,6 9,6 C9.553,6 10,6.448 10,7"
                            id="Fill-23"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M16,7 C16,7.552 15.553,8 15,8 C14.447,8 14,7.552 14,7 C14,6.448 14.447,6 15,6 C15.553,6 16,6.448 16,7"
                            id="Fill-24"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M10,13 C10,13.552 9.553,14 9,14 C8.447,14 8,13.552 8,13 C8,12.448 8.447,12 9,12 C9.553,12 10,12.448 10,13"
                            id="Fill-25"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M16,13 C16,13.552 15.553,14 15,14 C14.447,14 14,13.552 14,13 C14,12.448 14.447,12 15,12 C15.553,12 16,12.448 16,13"
                            id="Fill-26"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M55,10 C55,10.552 54.553,11 54,11 C53.447,11 53,10.552 53,10 C53,9.448 53.447,9 54,9 C54.553,9 55,9.448 55,10"
                            id="Fill-27"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M58,7 C58,7.552 57.553,8 57,8 C56.447,8 56,7.552 56,7 C56,6.448 56.447,6 57,6 C57.553,6 58,6.448 58,7"
                            id="Fill-28"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M58,13 C58,13.552 57.553,14 57,14 C56.447,14 56,13.552 56,13 C56,12.448 56.447,12 57,12 C57.553,12 58,12.448 58,13"
                            id="Fill-29"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M49,10 C49,10.552 48.553,11 48,11 C47.447,11 47,10.552 47,10 C47,9.448 47.447,9 48,9 C48.553,9 49,9.448 49,10"
                            id="Fill-30"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M52,7 C52,7.552 51.553,8 51,8 C50.447,8 50,7.552 50,7 C50,6.448 50.447,6 51,6 C51.553,6 52,6.448 52,7"
                            id="Fill-31"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M52,13 C52,13.552 51.553,14 51,14 C50.447,14 50,13.552 50,13 C50,12.448 50.447,12 51,12 C51.553,12 52,12.448 52,13"
                            id="Fill-32"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M34,7 C34,7.552 33.553,8 33,8 C32.447,8 32,7.552 32,7 C32,6.448 32.447,6 33,6 C33.553,6 34,6.448 34,7"
                            id="Fill-33"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M34,13 C34,13.552 33.553,14 33,14 C32.447,14 32,13.552 32,13 C32,12.448 32.447,12 33,12 C33.553,12 34,12.448 34,13"
                            id="Fill-34"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M37,10 C37,10.552 36.553,11 36,11 C35.447,11 35,10.552 35,10 C35,9.448 35.447,9 36,9 C36.553,9 37,9.448 37,10"
                            id="Fill-35"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M43,10 C43,10.552 42.553,11 42,11 C41.447,11 41,10.552 41,10 C41,9.448 41.447,9 42,9 C42.553,9 43,9.448 43,10"
                            id="Fill-36"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M40,7 C40,7.552 39.553,8 39,8 C38.447,8 38,7.552 38,7 C38,6.448 38.447,6 39,6 C39.553,6 40,6.448 40,7"
                            id="Fill-37"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M46,7 C46,7.552 45.553,8 45,8 C44.447,8 44,7.552 44,7 C44,6.448 44.447,6 45,6 C45.553,6 46,6.448 46,7"
                            id="Fill-38"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M40,13 C40,13.552 39.553,14 39,14 C38.447,14 38,13.552 38,13 C38,12.448 38.447,12 39,12 C39.553,12 40,12.448 40,13"
                            id="Fill-39"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M46,13 C46,13.552 45.553,14 45,14 C44.447,14 44,13.552 44,13 C44,12.448 44.447,12 45,12 C45.553,12 46,12.448 46,13"
                            id="Fill-40"
                            fill="#FFFFFF"
                            mask="url(#mask-2)"
                        ></path>
                        <polygon
                            id="Stroke-41"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                            points="37 37 53 37 53 27 37 27"
                        ></polygon>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function DebitCardInActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 60 44">
            <defs>
                <polygon id="path-1" points="0 44 60 44 60 0 0 0"></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="assets-and-interactions" transform="translate(-106.000000, -521.000000)">
                    <g id="icon-debit-card" transform="translate(106.000000, 521.000000)">
                        <path
                            d="M55.7832,43 L4.2172,43 C2.4402,43 1.0002,41.56 1.0002,39.783 L1.0002,4.217 C1.0002,2.44 2.4402,1 4.2172,1 L55.7832,1 C57.5592,1 59.0002,2.44 59.0002,4.217 L59.0002,39.783 C59.0002,41.56 57.5592,43 55.7832,43 Z"
                            id="Stroke-1"
                            stroke="#000000"
                            strokeWidth="2"
                        ></path>
                        <mask id="mask-2" fill="white">
                            <use xlinkHref="#path-1"></use>
                        </mask>
                        <g id="Clip-4"></g>
                        <polygon
                            id="Stroke-3"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                            points="1 14 59 14 59 6 1 6"
                        ></polygon>
                        <path
                            d="M7,20 L16,20"
                            id="Stroke-5"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M20,20 L29,20"
                            id="Stroke-6"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M7,25 L8,25"
                            id="Stroke-7"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M12,25 L14,25"
                            id="Stroke-8"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M18,25 L19,25"
                            id="Stroke-9"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M23,25 L25,25"
                            id="Stroke-10"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M29,25 L29,25"
                            id="Stroke-11"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M25,10 C25,10.552 24.553,11 24,11 C23.447,11 23,10.552 23,10 C23,9.448 23.447,9 24,9 C24.553,9 25,9.448 25,10"
                            id="Fill-12"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M28,7 C28,7.552 27.553,8 27,8 C26.447,8 26,7.552 26,7 C26,6.448 26.447,6 27,6 C27.553,6 28,6.448 28,7"
                            id="Fill-13"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M28,13 C28,13.552 27.553,14 27,14 C26.447,14 26,13.552 26,13 C26,12.448 26.447,12 27,12 C27.553,12 28,12.448 28,13"
                            id="Fill-14"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M31,10 C31,10.552 30.553,11 30,11 C29.447,11 29,10.552 29,10 C29,9.448 29.447,9 30,9 C30.553,9 31,9.448 31,10"
                            id="Fill-15"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M19,10 C19,10.552 18.553,11 18,11 C17.447,11 17,10.552 17,10 C17,9.448 17.447,9 18,9 C18.553,9 19,9.448 19,10"
                            id="Fill-16"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M22,7 C22,7.552 21.553,8 21,8 C20.447,8 20,7.552 20,7 C20,6.448 20.447,6 21,6 C21.553,6 22,6.448 22,7"
                            id="Fill-17"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M22,13 C22,13.552 21.553,14 21,14 C20.447,14 20,13.552 20,13 C20,12.448 20.447,12 21,12 C21.553,12 22,12.448 22,13"
                            id="Fill-18"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M4,7 C4,7.552 3.553,8 3,8 C2.447,8 2,7.552 2,7 C2,6.448 2.447,6 3,6 C3.553,6 4,6.448 4,7"
                            id="Fill-19"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M4,13 C4,13.552 3.553,14 3,14 C2.447,14 2,13.552 2,13 C2,12.448 2.447,12 3,12 C3.553,12 4,12.448 4,13"
                            id="Fill-20"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M7,10 C7,10.552 6.553,11 6,11 C5.447,11 5,10.552 5,10 C5,9.448 5.447,9 6,9 C6.553,9 7,9.448 7,10"
                            id="Fill-21"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M13,10 C13,10.552 12.553,11 12,11 C11.447,11 11,10.552 11,10 C11,9.448 11.447,9 12,9 C12.553,9 13,9.448 13,10"
                            id="Fill-22"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M10,7 C10,7.552 9.553,8 9,8 C8.447,8 8,7.552 8,7 C8,6.448 8.447,6 9,6 C9.553,6 10,6.448 10,7"
                            id="Fill-23"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M16,7 C16,7.552 15.553,8 15,8 C14.447,8 14,7.552 14,7 C14,6.448 14.447,6 15,6 C15.553,6 16,6.448 16,7"
                            id="Fill-24"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M10,13 C10,13.552 9.553,14 9,14 C8.447,14 8,13.552 8,13 C8,12.448 8.447,12 9,12 C9.553,12 10,12.448 10,13"
                            id="Fill-25"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M16,13 C16,13.552 15.553,14 15,14 C14.447,14 14,13.552 14,13 C14,12.448 14.447,12 15,12 C15.553,12 16,12.448 16,13"
                            id="Fill-26"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M55,10 C55,10.552 54.553,11 54,11 C53.447,11 53,10.552 53,10 C53,9.448 53.447,9 54,9 C54.553,9 55,9.448 55,10"
                            id="Fill-27"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M58,7 C58,7.552 57.553,8 57,8 C56.447,8 56,7.552 56,7 C56,6.448 56.447,6 57,6 C57.553,6 58,6.448 58,7"
                            id="Fill-28"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M58,13 C58,13.552 57.553,14 57,14 C56.447,14 56,13.552 56,13 C56,12.448 56.447,12 57,12 C57.553,12 58,12.448 58,13"
                            id="Fill-29"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M49,10 C49,10.552 48.553,11 48,11 C47.447,11 47,10.552 47,10 C47,9.448 47.447,9 48,9 C48.553,9 49,9.448 49,10"
                            id="Fill-30"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M52,7 C52,7.552 51.553,8 51,8 C50.447,8 50,7.552 50,7 C50,6.448 50.447,6 51,6 C51.553,6 52,6.448 52,7"
                            id="Fill-31"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M52,13 C52,13.552 51.553,14 51,14 C50.447,14 50,13.552 50,13 C50,12.448 50.447,12 51,12 C51.553,12 52,12.448 52,13"
                            id="Fill-32"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M34,7 C34,7.552 33.553,8 33,8 C32.447,8 32,7.552 32,7 C32,6.448 32.447,6 33,6 C33.553,6 34,6.448 34,7"
                            id="Fill-33"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M34,13 C34,13.552 33.553,14 33,14 C32.447,14 32,13.552 32,13 C32,12.448 32.447,12 33,12 C33.553,12 34,12.448 34,13"
                            id="Fill-34"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M37,10 C37,10.552 36.553,11 36,11 C35.447,11 35,10.552 35,10 C35,9.448 35.447,9 36,9 C36.553,9 37,9.448 37,10"
                            id="Fill-35"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M43,10 C43,10.552 42.553,11 42,11 C41.447,11 41,10.552 41,10 C41,9.448 41.447,9 42,9 C42.553,9 43,9.448 43,10"
                            id="Fill-36"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M40,7 C40,7.552 39.553,8 39,8 C38.447,8 38,7.552 38,7 C38,6.448 38.447,6 39,6 C39.553,6 40,6.448 40,7"
                            id="Fill-37"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M46,7 C46,7.552 45.553,8 45,8 C44.447,8 44,7.552 44,7 C44,6.448 44.447,6 45,6 C45.553,6 46,6.448 46,7"
                            id="Fill-38"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M40,13 C40,13.552 39.553,14 39,14 C38.447,14 38,13.552 38,13 C38,12.448 38.447,12 39,12 C39.553,12 40,12.448 40,13"
                            id="Fill-39"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <path
                            d="M46,13 C46,13.552 45.553,14 45,14 C44.447,14 44,13.552 44,13 C44,12.448 44.447,12 45,12 C45.553,12 46,12.448 46,13"
                            id="Fill-40"
                            fill="#000000"
                            mask="url(#mask-2)"
                        ></path>
                        <polygon
                            id="Stroke-41"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-2)"
                            points="37 37 53 37 53 27 37 27"
                        ></polygon>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function CheckActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 60 59">
            <defs>
                <polygon id="path-2" points="0 59.0156 60 59.0156 60 -0.0004 0 -0.0004"></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="assets-and-interactions" transform="translate(-666.000000, -661.000000)">
                    <g id="icon-check-selected" transform="translate(666.000000, 661.000000)">
                        <path
                            d="M55,50 L51,57 L47,50 L47,2.985 C47,1.889 47.889,1 48.985,1 L53.015,1 C54.111,1 55,1.889 55,2.985 L55,50 Z"
                            id="Stroke-1"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                        ></path>
                        <mask id="mask-3" fill="white">
                            <use xlinkHref="#path-2"></use>
                        </mask>
                        <g id="Clip-4"></g>
                        <polygon
                            id="Stroke-3"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            mask="url(#mask-3)"
                            points="47 11.9996 55 11.9996 55 7.9996 47 7.9996"
                        ></polygon>
                        <path
                            d="M47,50 L55,50"
                            id="Stroke-5"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            mask="url(#mask-3)"
                        ></path>
                        <polygon
                            id="Stroke-6"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            mask="url(#mask-3)"
                            points="1 46.9996 47 46.9996 47 15.9996 1 15.9996"
                        ></polygon>
                        <polygon
                            id="Stroke-7"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            mask="url(#mask-3)"
                            points="55 46.9996 59 46.9996 59 15.9996 55 15.9996"
                        ></polygon>
                        <path
                            d="M36,27 L39,27"
                            id="Stroke-8"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M21,23 L24,23"
                            id="Stroke-9"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M32,23 L39,23"
                            id="Stroke-10"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M28,23 L28,23"
                            id="Stroke-11"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M25,27 L32,27"
                            id="Stroke-12"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M21,27 L21,27"
                            id="Stroke-13"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M6,34.2227 C6,36.4317 7.791,38.2227 10,38.2227 C11.225,38.2227 12.321,37.6717 13.055,36.8047 C13.986,35.7027 13.753,34.0307 12.615,33.1457 L7.385,29.0767 C6.247,28.1917 6.014,26.5187 6.945,25.4177 C7.679,24.5507 8.775,23.9997 10,23.9997 C12.209,23.9997 14,25.7907 14,27.9997"
                            id="Stroke-14"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <polyline
                            id="Stroke-15"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                            points="10 22 10 35 10 40"
                        ></polyline>
                        <path
                            d="M24.1445,33.4004 C21.3025,34.8794 20.9035,38.1134 20.8065,41.0004 C21.3745,40.7644 21.9435,40.5284 22.5135,40.2934 C21.5775,39.5094 20.6425,38.7254 19.7075,37.9424 C18.7265,37.1214 17.3045,38.5284 18.2925,39.3564 C19.2275,40.1394 20.1635,40.9234 21.0995,41.7074 C21.7575,42.2584 22.7755,41.9104 22.8065,41.0004 C22.8785,38.8344 22.9805,36.2574 25.1545,35.1274 C26.2965,34.5334 25.2865,32.8064 24.1445,33.4004"
                            id="Fill-16"
                            fill="#FFFFFF"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M25.1318,38.5039 C25.6498,39.5539 26.6318,40.2869 27.8008,40.4359 C28.3958,40.5109 28.9328,40.4269 29.4888,40.2099 C29.8988,40.0509 31.4258,38.9019 31.7568,39.4929 C32.3838,40.6159 34.1118,39.6089 33.4838,38.4829 C32.9458,37.5229 31.8588,37.1419 30.7948,37.3889 C29.4098,37.7099 27.8338,39.4719 26.8588,37.4949 C26.2898,36.3409 24.5638,37.3529 25.1318,38.5039"
                            id="Fill-17"
                            fill="#FFFFFF"
                            mask="url(#mask-3)"
                        ></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function CheckInActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 60 59">
            <defs>
                <polygon id="path-3" points="0 59.0156 60 59.0156 60 -0.0004 0 -0.0004"></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="assets-and-interactions" transform="translate(-106.000000, -659.000000)">
                    <g id="icon-check" transform="translate(106.000000, 659.000000)">
                        <path
                            d="M55,50 L51,57 L47,50 L47,2.985 C47,1.889 47.889,1 48.985,1 L53.015,1 C54.111,1 55,1.889 55,2.985 L55,50 Z"
                            id="Stroke-1"
                            stroke="#000000"
                            strokeWidth="2"
                        ></path>
                        <mask id="mask-3" fill="white">
                            <use xlinkHref="#path-3"></use>
                        </mask>
                        <g id="Clip-4"></g>
                        <polygon
                            id="Stroke-3"
                            stroke="#000000"
                            strokeWidth="2"
                            mask="url(#mask-3)"
                            points="47 11.9996 55 11.9996 55 7.9996 47 7.9996"
                        ></polygon>
                        <path
                            d="M47,50 L55,50"
                            id="Stroke-5"
                            stroke="#000000"
                            strokeWidth="2"
                            mask="url(#mask-3)"
                        ></path>
                        <polygon
                            id="Stroke-6"
                            stroke="#000000"
                            strokeWidth="2"
                            mask="url(#mask-3)"
                            points="1 46.9996 47 46.9996 47 15.9996 1 15.9996"
                        ></polygon>
                        <polygon
                            id="Stroke-7"
                            stroke="#000000"
                            strokeWidth="2"
                            mask="url(#mask-3)"
                            points="55 46.9996 59 46.9996 59 15.9996 55 15.9996"
                        ></polygon>
                        <path
                            d="M36,27 L39,27"
                            id="Stroke-8"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M21,23 L24,23"
                            id="Stroke-9"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M32,23 L39,23"
                            id="Stroke-10"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M28,23 L28,23"
                            id="Stroke-11"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M25,27 L32,27"
                            id="Stroke-12"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M21,27 L21,27"
                            id="Stroke-13"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M6,34.2227 C6,36.4317 7.791,38.2227 10,38.2227 C11.225,38.2227 12.321,37.6717 13.055,36.8047 C13.986,35.7027 13.753,34.0307 12.615,33.1457 L7.385,29.0767 C6.247,28.1917 6.014,26.5187 6.945,25.4177 C7.679,24.5507 8.775,23.9997 10,23.9997 C12.209,23.9997 14,25.7907 14,27.9997"
                            id="Stroke-14"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                        ></path>
                        <polyline
                            id="Stroke-15"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="round"
                            mask="url(#mask-3)"
                            points="10 22 10 35 10 40"
                        ></polyline>
                        <path
                            d="M24.1445,33.4004 C21.3025,34.8794 20.9035,38.1134 20.8065,41.0004 C21.3745,40.7644 21.9435,40.5284 22.5135,40.2934 C21.5775,39.5094 20.6425,38.7254 19.7075,37.9424 C18.7265,37.1214 17.3045,38.5284 18.2925,39.3564 C19.2275,40.1394 20.1635,40.9234 21.0995,41.7074 C21.7575,42.2584 22.7755,41.9104 22.8065,41.0004 C22.8785,38.8344 22.9805,36.2574 25.1545,35.1274 C26.2965,34.5334 25.2865,32.8064 24.1445,33.4004"
                            id="Fill-16"
                            fill="#000000"
                            mask="url(#mask-3)"
                        ></path>
                        <path
                            d="M25.1318,38.5039 C25.6498,39.5539 26.6318,40.2869 27.8008,40.4359 C28.3958,40.5109 28.9328,40.4269 29.4888,40.2099 C29.8988,40.0509 31.4258,38.9019 31.7568,39.4929 C32.3838,40.6159 34.1118,39.6089 33.4838,38.4829 C32.9458,37.5229 31.8588,37.1419 30.7948,37.3889 C29.4098,37.7099 27.8338,39.4719 26.8588,37.4949 C26.2898,36.3409 24.5638,37.3529 25.1318,38.5039"
                            id="Fill-17"
                            fill="#000000"
                            mask="url(#mask-3)"
                        ></path>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function PatientPaymentPlanActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 58 55">
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g
                    id="assets-and-nteractions"
                    transform="translate(-510.000000, -664.000000)"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                >
                    <g id="modules/tabs/payment-plans-active" transform="translate(371.000000, 649.000000)">
                        <g id="icon-payment-plans-active" transform="translate(140.000000, 16.000000)">
                            <g id="Group-5" transform="translate(0.000000, 7.000000)">
                                <polygon
                                    id="Stroke-1"
                                    points="10.499 2.8203 20.345 1.9593 3.66 0.4993 0 42.3403 14.064 43.5703"
                                ></polygon>
                                <polygon
                                    id="Stroke-3"
                                    points="20.3447 44.1191 41.8397 46.0001 42.1717 42.2101"
                                ></polygon>
                            </g>
                            <line x1="31" y1="14" x2="36.465" y2="8.535" id="Stroke-6"></line>
                            <g id="Group-29" transform="translate(10.000000, 0.000000)">
                                <path
                                    d="M35,5 C35,2.238 32.762,0 30,0 C27.238,0 25,2.238 25,5 C25,7.762 27.238,10 30,10 C32.762,10 35,7.762 35,5 Z"
                                    id="Stroke-7"
                                ></path>
                                <path
                                    d="M42.3398,6.1602 L34.6428,6.8332 C33.9098,8.6852 32.1118,10.0002 29.9998,10.0002 C28.1988,10.0002 26.6338,9.0392 25.7538,7.6112 L0.4988,9.8202 L4.1598,51.6602 L45.9998,48.0002 L42.3398,6.1602 Z"
                                    id="Stroke-9"
                                ></path>
                                <line x1="33.1758" y1="21.1191" x2="36.1638" y2="20.8571" id="Stroke-11"></line>
                                <line x1="22.2178" y1="22.0781" x2="29.1908" y2="21.4681" id="Stroke-13"></line>
                                <line x1="9.2666" y1="23.2109" x2="18.2326" y2="22.4269" id="Stroke-15"></line>
                                <line x1="29.7139" y1="27.4453" x2="36.6879" y2="26.8353" id="Stroke-17"></line>
                                <line x1="16.7637" y1="28.5781" x2="23.7377" y2="27.9681" id="Stroke-19"></line>
                                <line x1="9.79" y1="29.1885" x2="12.778" y2="28.9265" id="Stroke-21"></line>
                                <line x1="35.2178" y1="32.9863" x2="37.2098" y2="32.8113" id="Stroke-23"></line>
                                <line x1="21.2705" y1="34.2061" x2="31.2335" y2="33.3351" id="Stroke-25"></line>
                                <line x1="10.3125" y1="35.165" x2="15.2935" y2="34.729" id="Stroke-27"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function PatientPaymentPlanInActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 58 55">
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g
                    id="assets-and-nteractions"
                    transform="translate(-506.000000, -262.000000)"
                    stroke="#000000"
                    strokeWidth="2"
                >
                    <g id="modules/tabs/payment-plans-active" transform="translate(372.000000, 247.000000)">
                        <g id="icon-payment-plans-Inactive" transform="translate(135.000000, 16.000000)">
                            <g id="Group-5" transform="translate(0.000000, 7.000000)">
                                <polygon
                                    id="Stroke-1"
                                    points="10.499 2.8203 20.345 1.9593 3.66 0.4993 0 42.3403 14.064 43.5703"
                                ></polygon>
                                <polygon
                                    id="Stroke-3"
                                    points="20.3447 44.1191 41.8397 46.0001 42.1717 42.2101"
                                ></polygon>
                            </g>
                            <line x1="31" y1="14" x2="36.465" y2="8.535" id="Stroke-6"></line>
                            <g id="Group-29" transform="translate(10.000000, 0.000000)">
                                <path
                                    d="M35,5 C35,2.238 32.762,0 30,0 C27.238,0 25,2.238 25,5 C25,7.762 27.238,10 30,10 C32.762,10 35,7.762 35,5 Z"
                                    id="Stroke-7"
                                ></path>
                                <path
                                    d="M42.3398,6.1602 L34.6428,6.8332 C33.9098,8.6852 32.1118,10.0002 29.9998,10.0002 C28.1988,10.0002 26.6338,9.0392 25.7538,7.6112 L0.4988,9.8202 L4.1598,51.6602 L45.9998,48.0002 L42.3398,6.1602 Z"
                                    id="Stroke-9"
                                ></path>
                                <line x1="33.1758" y1="21.1191" x2="36.1638" y2="20.8571" id="Stroke-11"></line>
                                <line x1="22.2178" y1="22.0781" x2="29.1908" y2="21.4681" id="Stroke-13"></line>
                                <line x1="9.2666" y1="23.2109" x2="18.2326" y2="22.4269" id="Stroke-15"></line>
                                <line x1="29.7139" y1="27.4453" x2="36.6879" y2="26.8353" id="Stroke-17"></line>
                                <line x1="16.7637" y1="28.5781" x2="23.7377" y2="27.9681" id="Stroke-19"></line>
                                <line x1="9.79" y1="29.1885" x2="12.778" y2="28.9265" id="Stroke-21"></line>
                                <line x1="35.2178" y1="32.9863" x2="37.2098" y2="32.8113" id="Stroke-23"></line>
                                <line x1="21.2705" y1="34.2061" x2="31.2335" y2="33.3351" id="Stroke-25"></line>
                                <line x1="10.3125" y1="35.165" x2="15.2935" y2="34.729" id="Stroke-27"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export function AppleGooglePayActiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 316 62">
            <rect width="316" height="62" fill="url(#pattern0)" />
            <defs>
                <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_1:5" transform="scale(0.00316456 0.016129)" />
                </pattern>
                <image
                    id="image0_1:5"
                    width="316"
                    height="62"
                    xlinkHref="data:image/png;base64,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"
                />
            </defs>
        </SvgIcon>
    )
}

export function AppleGooglePayInactiveIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 316 60">
            <rect width="316" height="60" fill="url(#pattern0)" />
            <defs>
                <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_0:1" transform="scale(0.00316456 0.0166667)" />
                </pattern>
                <image
                    id="image0_0:1"
                    width="316"
                    height="60"
                    xlinkHref="data:image/png;base64,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"
                />
            </defs>
        </SvgIcon>
    )
}

export function InvoiceNotAvailableIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 129 160">
            <defs>
                <polyline
                    id="path-1"
                    points="0 0 0 131.854285 0.00946293213 131.854285 4.4269399 126.447897 8.77682449 131.854285 13.1943015 126.447897 17.544186 131.854285 21.961663 126.447897 26.3115476 131.854285 30.7290246 126.447897 35.0789092 131.854285 39.4963861 126.447897 43.8462707 131.854285 48.2637477 126.447897 52.613452 131.854285 57.0310191 126.447897 61.3808136 131.854285 65.7983807 126.447897 70.1481752 131.854285 74.5657422 126.447897 78.9155367 131.854285 83.3331038 126.447897 87.6828081 131.854285 92.1004654 126.447897 96.4501697 131.854285 100.867827 126.447897 105.205455 131.839081 105.205455 0"
                ></polyline>
                <polygon id="path-3" points="0 0 71.9639766 0 71.9639766 71.8381115 0 71.8381115"></polygon>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="$large-payment-invoice-unavailable" transform="translate(-489.000000, -320.000000)">
                    <g id="icon-invoice-unavailable" transform="translate(490.000000, 320.000000)">
                        <polygon
                            id="Fill-1"
                            fill="#3C6F7A"
                            opacity="0.2"
                            points="9.99395583 160 14.4114328 154.593522 18.7613174 160 23.1787944 154.593522 27.528679 160 31.9461559 154.593522 36.2960405 160 40.7135175 154.593522 45.0634021 160 49.4807889 154.593522 53.8306735 160 58.2481505 154.593522 62.5979449 160 67.015512 154.593522 71.3653065 160 75.7828736 154.593522 80.1325779 160 84.5502351 154.593522 88.8999395 160 93.3175967 154.593522 97.667301 160 102.084958 154.593522 106.434663 160 110.85223 154.593522 115.189948 159.984796 115.189948 30.329808 9.9844929 30.329808 9.9844929 160"
                        ></polygon>
                        <polygon
                            id="Fill-3"
                            stroke="#CFDAE9"
                            strokeWidth="0.6"
                            fill="#FFFFFF"
                            points="0 17.9707039 0 149.824989 0.00946293213 149.824989 4.4269399 144.418601 8.77682449 149.824989 13.1943015 144.418601 17.544186 149.824989 21.961663 144.418601 26.3115476 149.824989 30.7290246 144.418601 35.0789092 149.824989 39.4963861 144.418601 43.8462707 149.824989 48.2637477 144.418601 52.613452 149.824989 57.0310191 144.418601 61.3808136 149.824989 65.7983807 144.418601 70.1481752 149.824989 74.5657422 144.418601 78.9155367 149.824989 83.3331038 144.418601 87.6828081 149.824989 92.1004654 144.418601 96.4501697 149.824989 100.867827 144.418601 105.205455 149.809785 105.205455 17.9707039"
                        ></polygon>
                        <g id="Group-36" transform="translate(10.596213, 34.309496)">
                            <path
                                d="M36.8390326,28.7548265 L1.87322797,28.7548265 C0.838614058,28.7548265 1.80246326e-05,27.9176973 1.80246326e-05,26.884893 C1.80246326e-05,25.8521788 0.838614058,25.0150495 1.87322797,25.0150495 L36.8390326,25.0150495 C37.8735564,25.0150495 38.7121524,25.8521788 38.7121524,26.884893 C38.7121524,27.9176973 37.8735564,28.7548265 36.8390326,28.7548265"
                                id="Fill-4"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M81.4158236,28.7548265 L68.2820849,28.7548265 C67.2476513,28.7548265 66.4090552,27.9176973 66.4090552,26.884893 C66.4090552,25.8521788 67.2476513,25.0150495 68.2820849,25.0150495 L81.4158236,25.0150495 C82.4504375,25.0150495 83.2890336,25.8521788 83.2890336,26.884893 C83.2890336,27.9176973 82.4504375,28.7548265 81.4158236,28.7548265"
                                id="Fill-6"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M81.4158236,37.0203912 L68.2820849,37.0203912 C67.2476513,37.0203912 66.4090552,36.183262 66.4090552,35.1504578 C66.4090552,34.1177435 67.2476513,33.2806143 68.2820849,33.2806143 L81.4158236,33.2806143 C82.4504375,33.2806143 83.2890336,34.1177435 83.2890336,35.1504578 C83.2890336,36.183262 82.4504375,37.0203912 81.4158236,37.0203912"
                                id="Fill-8"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M81.4158236,45.285947 L68.2820849,45.285947 C67.2476513,45.285947 66.4090552,44.4488178 66.4090552,43.4160135 C66.4090552,42.3833892 67.2476513,41.54617 68.2820849,41.54617 L81.4158236,41.54617 C82.4504375,41.54617 83.2890336,42.3833892 83.2890336,43.4160135 C83.2890336,44.4488178 82.4504375,45.285947 81.4158236,45.285947"
                                id="Fill-10"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M81.4158236,61.8171035 L68.2820849,61.8171035 C67.2476513,61.8171035 66.4090552,60.9799742 66.4090552,59.94717 C66.4090552,58.9144557 67.2476513,58.0773265 68.2820849,58.0773265 L81.4158236,58.0773265 C82.4504375,58.0773265 83.2890336,58.9144557 83.2890336,59.94717 C83.2890336,60.9799742 82.4504375,61.8171035 81.4158236,61.8171035"
                                id="Fill-12"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M81.4158236,70.0826682 L68.2820849,70.0826682 C67.2476513,70.0826682 66.4090552,69.245539 66.4090552,68.2127347 C66.4090552,67.1800205 67.2476513,66.3428912 68.2820849,66.3428912 L81.4158236,66.3428912 C82.4504375,66.3428912 83.2890336,67.1800205 83.2890336,68.2127347 C83.2890336,69.245539 82.4504375,70.0826682 81.4158236,70.0826682"
                                id="Fill-14"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M23.2918989,37.0203912 L1.87322797,37.0203912 C0.838704181,37.0203912 1.80246326e-05,36.183262 1.80246326e-05,35.1504578 C1.80246326e-05,34.1177435 0.838704181,33.2806143 1.87322797,33.2806143 L23.2918989,33.2806143 C24.3264227,33.2806143 25.1650188,34.1177435 25.1650188,35.1504578 C25.1650188,36.183262 24.3264227,37.0203912 23.2918989,37.0203912"
                                id="Fill-16"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M28.4474035,45.285947 L1.87323698,45.285947 C0.83862307,45.285947 2.70369489e-05,44.4488178 2.70369489e-05,43.4160135 C2.70369489e-05,42.3833892 0.83862307,41.54617 1.87323698,41.54617 L28.4474035,41.54617 C29.4818372,41.54617 30.3205233,42.3833892 30.3205233,43.4160135 C30.3205233,44.4488178 29.4818372,45.285947 28.4474035,45.285947"
                                id="Fill-18"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M31.103261,61.8171035 L1.87325501,61.8171035 C0.838641095,61.8171035 4.50615816e-05,60.9799742 4.50615816e-05,59.94717 C4.50615816e-05,58.9144557 0.838641095,58.0773265 1.87325501,58.0773265 L31.103261,58.0773265 C32.1377848,58.0773265 32.9763808,58.9144557 32.9763808,59.94717 C32.9763808,60.9799742 32.1377848,61.8171035 31.103261,61.8171035"
                                id="Fill-20"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M34.5402701,70.0826682 L1.87323698,70.0826682 C0.83862307,70.0826682 2.70369489e-05,69.245539 2.70369489e-05,68.2127347 C2.70369489e-05,67.1800205 0.83862307,66.3428912 1.87323698,66.3428912 L34.5402701,66.3428912 C35.5747938,66.3428912 36.4133899,67.1800205 36.4133899,68.2127347 C36.4133899,69.245539 35.5747938,70.0826682 34.5402701,70.0826682"
                                id="Fill-22"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M81.4158236,3.73977696 L68.2820849,3.73977696 C67.2476513,3.73977696 66.4090552,2.90264774 66.4090552,1.86975353 C66.4090552,0.837129223 67.2476513,0 68.2820849,0 L81.4158236,0 C82.4504375,0 83.2890336,0.837129223 83.2890336,1.86975353 C83.2890336,2.90264774 82.4504375,3.73977696 81.4158236,3.73977696"
                                id="Fill-24"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M81.4158236,12.0053327 L68.2820849,12.0053327 C67.2476513,12.0053327 66.4090552,11.1682035 66.4090552,10.1353992 C66.4090552,9.10268496 67.2476513,8.26555574 68.2820849,8.26555574 L81.4158236,8.26555574 C82.4504375,8.26555574 83.2890336,9.10268496 83.2890336,10.1353992 C83.2890336,11.1682035 82.4504375,12.0053327 81.4158236,12.0053327"
                                id="Fill-26"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M31.103261,3.73977696 L1.87325501,3.73977696 C0.838641095,3.73977696 4.50615816e-05,2.90264774 4.50615816e-05,1.86975353 C4.50615816e-05,0.837129223 0.838641095,0 1.87325501,0 L31.103261,0 C32.1377848,0 32.9763808,0.837129223 32.9763808,1.86975353 C32.9763808,2.90264774 32.1377848,3.73977696 31.103261,3.73977696"
                                id="Fill-28"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M34.5402701,12.0053327 L1.87323698,12.0053327 C0.83862307,12.0053327 2.70369489e-05,11.1682035 2.70369489e-05,10.1353992 C2.70369489e-05,9.10268496 0.83862307,8.26555574 1.87323698,8.26555574 L34.5402701,8.26555574 C35.5747938,8.26555574 36.4133899,9.10268496 36.4133899,10.1353992 C36.4133899,11.1682035 35.5747938,12.0053327 34.5402701,12.0053327"
                                id="Fill-30"
                                fill="#C4C4C4"
                            ></path>
                            <path
                                d="M41.178535,80.7200391 L7.70760328,80.7200391 C3.45081592,80.7200391 0,84.1648191 0,88.4140708 L0,88.4141608 C0,92.6634125 3.45081592,96.1081925 7.70760328,96.1081925 L41.178535,96.1081925 C45.4353223,96.1081925 48.8860481,92.6634125 48.8860481,88.4141608 L48.8860481,88.4140708 C48.8860481,84.1648191 45.4353223,80.7200391 41.178535,80.7200391"
                                id="Fill-32"
                                fill="#E8E8E8"
                            ></path>
                            <path
                                d="M75.6274742,88.8372417 L75.6274742,91.5837093 C76.3609866,91.5837093 76.7279682,91.1443176 76.7279682,90.2654444 C76.7279682,89.3135192 76.3609866,88.8372417 75.6274742,88.8372417 M72.326443,84.2237195 C72.326443,85.1025928 72.6928838,85.5419844 73.4269369,85.5419844 L73.4269369,82.7955168 C72.6928838,82.7955168 72.326443,83.2717043 72.326443,84.2237195 M75.6274742,94.8795064 L75.6274742,97.0767344 L73.4269369,97.0767344 L73.4269369,94.8795064 L69.024871,94.8795064 L69.024871,91.5837093 L73.4269369,91.5837093 L73.4269369,88.8372417 C70.4918959,88.8372417 69.024871,87.2997308 69.024871,84.2237195 C69.024871,81.0745662 70.4918959,79.4997197 73.4269369,79.4997197 L73.4269369,77.3024917 L75.6274742,77.3024917 L75.6274742,79.4997197 L80.0295401,79.4997197 L80.0295401,82.7955168 L75.6274742,82.7955168 L75.6274742,85.5419844 C78.5619745,85.5419844 80.0295401,87.1162911 80.0295401,90.2654444 C80.0295401,93.3414557 78.5619745,94.8795064 75.6274742,94.8795064"
                                id="Fill-34"
                                fill="#F55B62"
                            ></path>
                        </g>
                        <g id="Group-39" transform="translate(0.000000, 17.970704)">
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#path-1"></use>
                            </mask>
                            <g id="Clip-38"></g>
                            <path
                                d="M97.6338113,64.7069941 C75.6818816,64.7069941 57.8228052,46.8790655 57.8228052,24.9658024 C57.8228052,3.05226941 75.6818816,-14.7756592 97.6338113,-14.7756592 C119.585561,-14.7756592 137.444727,3.05226941 137.444727,24.9658024 C137.444727,46.8790655 119.585561,64.7069941 97.6338113,64.7069941"
                                id="Fill-37"
                                stroke="#979797"
                                strokeWidth="0.6"
                                fill="#595959"
                                opacity="0.4"
                                mask="url(#mask-2)"
                            ></path>
                        </g>
                        <g id="Group-45" transform="translate(56.036023, 0.000000)">
                            <g id="Group-42">
                                <mask id="mask-4" fill="white">
                                    <use xlinkHref="#path-3"></use>
                                </mask>
                                <g id="Clip-41"></g>
                                <path
                                    d="M71.9639766,35.9190153 C71.9639766,55.7565938 55.8541909,71.8381115 35.9819433,71.8381115 C16.1096055,71.8381115 0,55.7565938 0,35.9190153 C0,16.0814368 16.1096055,-8.09689737e-05 35.9819433,-8.09689737e-05 C55.8541909,-8.09689737e-05 71.9639766,16.0814368 71.9639766,35.9190153"
                                    id="Fill-40"
                                    fill="#9ED13F"
                                    mask="url(#mask-4)"
                                ></path>
                            </g>
                            <path
                                d="M29.9946289,58.7392569 C28.7959909,57.6273729 28.1966718,56.25171 28.1966718,54.6143375 C28.1966718,52.9356707 28.7959909,51.5285199 29.9946289,50.3949543 C31.193267,49.2613887 32.7388793,48.6946058 34.6314657,48.6946058 C36.4816041,48.6946058 38.0065781,49.2613887 39.2052162,50.3949543 C40.4038543,51.5285199 41.0031733,52.9356707 41.0031733,54.6143375 C41.0031733,56.25171 40.4038543,57.6273729 39.2052162,58.7392569 C38.0065781,59.8522204 36.4816041,60.4081174 34.6314657,60.4081174 C32.7388793,60.4081174 31.193267,59.8522204 29.9946289,58.7392569 M49.6144416,16.7658405 C52.3271488,19.1176294 53.6835024,22.4336687 53.6835024,26.7160278 C53.6835024,30.6628154 52.390235,33.7378371 49.8037002,35.9419925 C47.2171654,38.1461479 43.7996951,39.2699073 39.5521904,39.3112014 L39.2367593,44.0343916 L29.7738272,44.0343916 L29.4583961,32.32088 L33.243569,32.32088 C36.4816041,32.32088 38.9528714,31.9223328 40.6561991,31.1243385 C42.3595269,30.3273339 43.2111908,28.878889 43.2111908,26.7790036 C43.2111908,25.3098666 42.8109539,24.1556988 42.0125527,23.3153309 C41.2130702,22.4759525 40.0982466,22.0558135 38.6689834,22.0558135 C37.1549143,22.0558135 35.9770045,22.4868383 35.1361554,23.3468188 C34.2943149,24.2077889 33.8744311,25.3729324 33.8744311,26.8419795 L23.7175506,26.8419795 C23.6327447,24.2816506 24.1689776,21.9721455 25.3262491,19.914634 C26.4824391,17.858112 28.2064953,16.2305457 30.4993187,15.0340042 C32.7910606,13.8374627 35.5560392,13.2391919 38.7951558,13.2391919 C43.2950054,13.2391919 46.9017343,14.4150413 49.6144416,16.7658405"
                                id="Fill-43"
                                fill="#FFFFFF"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}
